import { Col, Label, Row, Input } from "reactstrap";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import CustomSelect from "../../../../../components/Forms/CustomSelect";
import { useSettings } from "../../../../../context/settings";

const EMPLOYMENT_STATUSES = ['active', 'probation', 'suspended', 'terminated'];

function JobInfosTab({ employeeData, setEmployeeData }) {
  const { t } = useTranslation();
  const { datePickerFormat } = useSettings();
  const isTerminated = employeeData.employment_status === 'terminated';

  return(
    <>
      <Row>
        <Col md="6" className="mb-3">
          <Label>Job Title</Label>
          <Input 
            value={employeeData.job_title || ''}
            onChange={e => setEmployeeData({ ...employeeData, job_title: e.target.value })}
          />
        </Col>
      </Row>
      <Row>
        <Col md="6" className="mb-3">
          <Label>Department</Label>
          <CustomSelect
            value={employeeData.department || null}
            onChange={selected => setEmployeeData({ ...employeeData, department: selected.label })}
            module="hr/departments"
            placeholder="Search Department"
            createLink="/hr/settings"
          />
        </Col>
      </Row>
      <Row>
        <Col md="6" className="mb-3">
          <Label>Position</Label>
          <CustomSelect
            value={employeeData.position || null}
            onChange={selected => setEmployeeData({ ...employeeData, position: selected.label })}
            module="hr/positions"
            placeholder="Search Position"
            createLink="/hr/settings"
          />
        </Col>
      </Row>

      <Row>
        <Col md="6" className="mb-3">
          <Label>{t('hr.employmentStatus.label')}</Label>
          <Input
            type="select"
            value={employeeData.employment_status || 'active'}
            onChange={e => setEmployeeData({ ...employeeData, employment_status: e.target.value })}
          >
            {EMPLOYMENT_STATUSES.map(status => (
              <option key={status} value={status}>{t(`hr.employmentStatus.${status}`)}</option>
            ))}
          </Input>
        </Col>
      </Row>

      {isTerminated && (
        <Row>
          <Col md="3" className="mb-3">
            <Label>{t('hr.employmentStatus.terminationDate')}</Label>
            <DatePicker
              selected={employeeData.termination_date}
              onChange={date => setEmployeeData({ ...employeeData, termination_date: date })}
              className="form-control"
              dateFormat={datePickerFormat}
              placeholderText={datePickerFormat.toLowerCase()}
            />
          </Col>
          <Col md="6" className="mb-3">
            <Label>{t('hr.employmentStatus.terminationReason')}</Label>
            <Input
              value={employeeData.termination_reason || ''}
              onChange={e => setEmployeeData({ ...employeeData, termination_reason: e.target.value })}
            />
          </Col>
        </Row>
      )}
    </>
  );
}

export default JobInfosTab;